import { FC, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import useApi from 'utils/use-api';
import SearchSelectInput from 'components/core/search-select-input';
import _ from 'lodash';

interface AssignableUserPickerProps {
  id: string;
  label?: string;
  required?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  setFieldValue: any;
  handleBlur?: any;
}

const AssignableUserPicker: FC<AssignableUserPickerProps> = ({ id, label, required, setFieldValue, ...form }) => {
  const api = useApi();
  const { data, isLoading } = useQuery({
    queryKey: ['assignable-users'],
    queryFn: async () => {
      const res = await api.get('/access-requests/assignable/users');
      return res.data ?? [];
    },
  });

  const options = useMemo(
    () =>
      (data || []).map((user: any) => ({
        label: { title: user.fullName || `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || user.email },
        value: Number(user.id),
      })),
    [data],
  );

  const handleSetValue = (field: string, val: any) => {
    const option = options.find((o: any) => _.isEqual(o.value, val));
    const rawId = typeof val === 'object' && val !== null ? (val.id ?? val.value ?? val) : val;
    const id = Number(rawId);
    const name =
      typeof val === 'object' && val !== null ? (val.fullName ?? val.name ?? val.label ?? option?.label.title ?? '') : (option?.label.title ?? '');

    setFieldValue('assigneeId', isNaN(id) ? 0 : id);
    setFieldValue('assigneeName', name);
    setFieldValue('assigneeType', 'user');
    setFieldValue(field, isNaN(id) ? '' : id);
  };

  return (
    <SearchSelectInput
      id={id}
      label={label ?? 'Select User'}
      required={required}
      optionsLoading={isLoading}
      options={options}
      setFieldValue={handleSetValue}
      {...form}
    />
  );
};

export default AssignableUserPicker;
